function JoyTycoonSpineSet(config,resources) {
    myPixiElement.container.call(this);


    this.config = $.extend(true,{
        slotCount:1,
        howlong_mili:7000
    },config);
    this.spineSet={};
    this.spineObj={};
    this.time_mili=0;
    var i;
    for(i=1;i<=this.config.slotCount;i++){
        this.spineSet[i]={blocked:0,time_mili_end:0,slot_id:i};
    }
    this.resources=resources;
}
JoyTycoonSpineSet.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonSpineSet.prototype = $.extend(JoyTycoonSpineSet.prototype, {
    findReady:function(){
        var i,bum,arr=[];
        for(i in this.spineSet){
            bum=this.spineSet[i];
            if(bum.blocked==0){
                arr.push(bum.slot_id);
            }
        }
        if(arr.length){
            return arr[mt_rand(0,arr.length-1)];
        }
        return 0;
    },
    playAnim:function(opt){
        opt=$.extend(true,{
            img:"",
            slot_id:1
        },opt);
        if(this.spineSet[opt.slot_id].blocked){
            return false;
        }
        this.spineSet[opt.slot_id].blocked=1;
        var obj=new myPixiElement.spine({
            img:opt.img,
            spine_conf:{
                freeze_part:0,
                anim_loop:true,
                updateAnim:true,
                spineResource:this.resources
            }
        });
        this.spineObj[opt.slot_id]=obj;
        obj.slot_id=opt.slot_id;
        obj.alpha=0;
        this.spineSet[opt.slot_id].time_mili_end=this.time_mili+this.config.howlong_mili;
        
        this.addChild(obj);
        obj.fadeIn(20);
        return true;
    },
    update:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        this.time_mili+=delta*1000/60;
        var i,bum;
        var thc=this;
        for(i in this.spineSet){
            bum=this.spineSet[i];
            if(bum.time_mili_end!=0 && bum.time_mili_end<this.time_mili){
                bum.time_mili_end=0;
                this.spineObj[bum.slot_id].fadeOut(20,{
                    onEnd:function(){
                        var slot_id=this.slot_id;
                        var obj=thc.spineObj[slot_id];
                        obj.conf.spine_conf.freeze_part=-1;
                        delete thc.spineObj[slot_id];
                        obj.myRemove();
                        
                        thc.spineSet[slot_id].blocked=0;
                    }
                });
            }
        }
        for(i in this.spineObj){
            this.spineObj[i].myUpdate(delta);
        }
    }
});



